const ledMode = {
    DAY: 'DAY',
    NIGHT: 'NIGHT'
}

export default ledMode;